import React from 'react'
import { motion } from "framer-motion";

const MenuSliderProducts = ({ singleProduct }) => {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: -300 }}
      whileInView={{ opacity: 1, translateY: 0 }}
      exit={{ opacity: 0, translateY: -300 }}
      transition={{ duration: 1 }}
      className="menu-slider__product">
      <img
        src={singleProduct.img}
        alt={singleProduct.name}
      />
      <section className="menu-slider__product-desc">
        <h2 className="pop-font txt-white">{singleProduct.name}</h2>
        <p className="menu-slider__product-desc-txt pop-font">
          {singleProduct.describtion}
        </p>
        <p className="menu-slider__product-price">
          <span>€</span>
          {singleProduct.price}
        </p>
      </section>
    </motion.div>
  )
}

export default MenuSliderProducts;
